<template>
  <div>
    <name-input
      v-if="currentStage === 'name'"
      :user="users"
      :startedField="'startedTrail'"
      @idChanged="lookupComp"
      @startCountdown="startCountdown"
    />
    <countdown v-if="currentStage === 'countdown'" @startGame="startGame" />
    <puzzle
      v-if="currentStage === 'puzzle'"
      :key="puzzleNumber"
      :number="puzzleNumber"
      :name="`/trailo/comp/T-${puzzleNumber}.jpg`"
      :options="['A', 'B', 'C', 'D', 'E', 'F', 'Z']"
      :keyboard="false"
      :countdown="false"
      :magnify="true"
      @complete="puzzleComplete"
    />
    <pause v-if="currentStage === 'pause'" @nextPuzzle="nextPuzzle" />
    <game-over
      v-if="currentStage === 'gameover'"
      :user="user.name"
      :time="userScore"
      :error="error"
    />
  </div>
</template>

<script>
import Countdown from '@/components/Countdown'
import Puzzle from '@/components/Puzzle'
import Pause from '@/components/Pause'
import NameInput from '@/components/NameInput'
import GameOver from '@/components/GameOver'

import firebase from 'firebase/app'
import 'firebase/firestore'

const db = firebase.firestore()

export default {
  components: {
    Countdown,
    Puzzle,
    Pause,
    GameOver,
    NameInput,
  },

  data: function() {
    return {
      puzzleNumber: 1,
      currentStage: 'name',
      choices: [],
      times: [],
      userScore: '',
      userScoreNumber: 0,
      userTime: 0,
      user: {},
      users: {},
      error: 1,
      solution: [
        'E',
        'A',
        'F',
        'C',
        'Z',
        'A',
        'E',
        'Z',
        'C',
        'F',
        'D',
        'B',
        'F',
        'Z',
        'E',
        'E',
        'Z',
        'C',
        'D',
        'F',
      ],
    }
  },

  methods: {
    lookupComp: async function(id) {
      try {
        if (this.currentStage === 'name')
          this.users = await db
            .collection('wod')
            .doc(id.toString())
            .get()
            .then(result => ({ id, ...result?.data() }))
      } catch (error) {
        this.users = {}
      }
    },

    startCountdown: function(user) {
      this.user = user
      this.setUserStarted(user.id)
      this.currentStage = 'countdown'
    },

    setUserStarted: function(userId) {
      return db
        .collection('wod')
        .doc(userId.toString())
        .update({ startedTrail: true, device: navigator.userAgent })
    },

    saveUserResult: function() {
      return Promise.resolve()
      /*
      return Promise.all([
        this.saveToMainDatabase({
          id: parseInt(this.user.id, 10),
          username: this.user.name.trim(),
          time: (this.userScore / 1000).toFixed(2).toString(),
        }),

        db
          .collection('wod')
          .doc(this.user.id.toString())
          .update({
            trailChoices: this.choices,
            trailTimes: this.times,
            trailScore: this.userScoreNumber,
            trailTime: this.userTime,
          }),
      ])
        .then(() => {
          this.error = 0
        })
        .catch(err => {
          console.log(err)
          this.error = 2
        }) */
    },

    saveToMainDatabase: function(result) {
      if (this.user.id > 20)
        return fetch(
          'https://europe-west3-coursechoicegame.cloudfunctions.net/saveTrailO',
          {
            method: 'POST',
            mode: 'no-cors',
            body: JSON.stringify(result),
          }
        ).then(async response => {
          console.log('response', await response.text())
        })
      else return Promise.resolve()
    },

    startGame: function() {
      this.currentStage = 'puzzle'
    },

    puzzleComplete: function(result) {
      this.choices.push(result.choice)
      this.times.push(result.time)

      if (this.puzzleNumber === this.solution.length) {
        this.currentStage = 'gameover'

        this.userTime = this.times.reduce((a, b) => a + b, 0)
        this.userScore = this.scoreUser()

        this.saveUserResult()
      } else if (this.puzzleNumber % 5 === 0) this.currentStage = 'pause'
      else this.puzzleNumber += 1
    },

    nextPuzzle: function() {
      this.puzzleNumber += 1
      this.currentStage = 'puzzle'
    },

    displayTime: function(milliseconds) {
      const minutes = Math.floor(milliseconds / 60000)
      const millisecondsOverMinutes = milliseconds - minutes * 60000
      const seconds = Math.round(millisecondsOverMinutes / 10) / 100

      return `${this.twoDigits(minutes)}:${this.twoDigits(seconds)}`
    },

    twoDigits: function(number) {
      const splitNumber = number.toString().split('.')
      if (splitNumber.length > 1 && splitNumber[0].toString().length < 2)
        return `0${splitNumber[0].toString()}.${splitNumber[1]}`
      else if (number.toString().length < 2) return `0${number.toString()}`
      else return number
    },

    scoreUser: function() {
      let correct = 0
      let i = 0

      while (i < this.choices.length) {
        if (this.solution[i] === this.choices[i]) correct += 1
        i += 1
      }

      this.userScoreNumber = correct
      return this.userTime + (this.choices.length - correct) * 30000
    },
  },
}
</script>
